export default "__VITE_ASSET__CbIYYhMc__"